import React from 'react';
import './main.less';

import { Link } from 'react-router';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';

import { isRequiredContentLanguage, namespace, actions, selectors } from './';

import wrapMain from '../../wrap-main';

import LangSwitch from '../../../shared/lang/switch';
import InputField from '../../../shared/form-elements/input';
import SelectField from '../../../shared/form-elements/select/field';
import { isSelected } from '../../../shared/form/validation';
import createLookupInEnum from '../../../shared/create-lookup-in-enum';

import { enum as popupTypes } from '../../../../../../../enums/popup-types';
import { enum as languages } from '../../../../../../../enums/languages';

function Editor({
	intl, lang, languageList, error, change, formValues,
	popupCampaignList, popupTypeList, popupCustomContentIdList, popupStatusList, ...props
}) {
	const type = formValues && formValues.type[0];
	return (
		<div className='form-container'>
			<div className='form-container__head'>
				<h2 className='icon-edit'>
					{intl('create/edit popup')}
				</h2>
			</div>
			<div className='form-container__body'>
				<form onSubmit={props.handleSubmit}>
					<div>
						<div className='banners-publication-editor-field'>
							<Field
								name='campaigns'
								component={SelectField}
								validate={[isSelected]}
								searchable={true}
								multi={true}
								options={createLookupInEnum(popupCampaignList.map((c) => ({ value: c.id, label: c.text })))}
								placeholder={
									`${intl('Campaigns')} (${intl('popup will be displayed if at least one campaign is suitable')})`
								}
							/>
						</div>
						<div className='banners-publication-editor-field'>
							<Field
								name='type'
								component={SelectField}
								validate={[isSelected]}
								searchable={false}
								options={popupTypeList.map((t) => ({ value: t.id, label: t.text }))}
								placeholder={intl('Type')}
								onChange={() => change('content', {})}
							/>
						</div>
						{type && type.value === popupTypes.simple && (
							<div className='banners-publication-editor-field'>
								<div className='banners-lang-switch clearfix'>
									<LangSwitch
										langs={languageList}
										onChangeLang={props.onChangeLang}
									/>
								</div>
								<div className='banners-fields-horizontally'>
									<Field
										className='banners-info-field banners-image-field'
										name={`content.${lang}.image`}
										component={InputField}
										placeholder={intl('Image link')}
									/>
									<Link
										className='banners-search'
										to={`/popups/images?langs=${isRequiredContentLanguage(lang) ? lang : [lang, languages.en]}`}
										target='_blank'
									/>
								</div>
								<Field
									className='banners-info-field'
									name={`content.${lang}.link`}
									component={InputField}
									placeholder={intl('Link')}
								/>
							</div>
						)}
						{type && type.value === popupTypes.custom && (
							<div className='banners-publication-editor-field'>
								<Field
									name='content.id'
									component={SelectField}
									validate={[isSelected]}
									searchable={false}
									options={popupCustomContentIdList.map((c) => ({ value: c.id, label: c.text }))}
									placeholder={intl('Custom content')}
								/>
							</div>
						)}
						<div className='banners-publication-editor-field'>
							<Field
								name='status'
								component={SelectField}
								validate={[isSelected]}
								searchable={false}
								options={popupStatusList.map((s) => ({ value: s.id, label: s.text }))}
								placeholder={intl('Status')}
							/>
						</div>
					</div>
					<div className='banners-buttons'>
						<button className='ui-btn ui-btn-primary'>
							{intl('Save')}
						</button>
						<Link
							className='ui-btn ui-btn-cancel'
							to='/popups/main'
						>
							{intl('Cancel')}
						</Link>
					</div>
					{error && (
						<div className='banners-error'>
							{intl(error)}
						</div>
					)}
				</form>
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		initialValues: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		lang: selectors.select(state, 'language'),
		// -----------------------------------------
		formValues: getFormValues(`${namespace}Form`)(state),
		popupCampaignList: selectors.getPopupCampaigns(state),
		popupTypeList: selectors.getPopupTypes(state),
		popupCustomContentIdList: selectors.getPopupCustomContentIds(state),
		popupStatusList: selectors.getPopupStatuses(state),
		languageList: selectors.getTabLangs(state)
	};
}

const Main = reduxForm({ form: `${namespace}Form`, enableReinitialize: true })(Editor);

export default connect(mapStateToProps, actions.own)(wrapMain(Main));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/popups/popup/editor/main.js